var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":_vm.size + 'px',"fill":_vm.color,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-width":"2","d":"M12,20 L24,20 M12,12 L24,12 M12,4 L24,4 M1,19 L4,22 L9,17 M1,11 L4,14 L9,9 M9,1 L4,6 L1,3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }